import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { PromoAuthProvider } from "./context/AuthContext";
import PromoProtectedRoute from "./components/ProtectedRoute";
import PromoLayout from "./components/Layout";

import PromoLogin from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import PromoDashboard from "./pages/Dashboard";
import PromoCodes from "./pages/PromoCodes";
import Referrals from "./pages/Referrals";
import Commissions from "./pages/Commissions";
import Payouts from "./pages/Payouts";
import Security from "./pages/Security";
// Phase 4 — advanced pages
import Campaigns from "./pages/Campaigns";
import Leaderboard from "./pages/Leaderboard";
import Contests from "./pages/Contests";
import Tickets from "./pages/Tickets";
import Forecast from "./pages/Forecast";
import Downline from "./pages/Downline";
// New session pages
import Funnel from "./pages/Funnel";
import Analytics from "./pages/Analytics";
import Settlements from "./pages/Settlements";
import Announcements from "./pages/Announcements";

import "./promo-theme.css";
import SiteNoticeBanner from "../components/site/SiteNoticeBanner";

export default function PromoApp() {
  return (
    <PromoAuthProvider>
      <div className="promo-shell">
        <SiteNoticeBanner />
        <Toaster
          position="top-center"
          richColors
          closeButton
          toastOptions={{
            style: {
              background: "linear-gradient(180deg, #14101e, #0a070f)",
              color: "#f5f1e6",
              border: "1px solid rgba(34, 192, 115, 0.35)",
              boxShadow: "0 18px 50px rgba(0,0,0,0.6)",
            },
          }}
        />
        <Routes>
          <Route path="login" element={<PromoLogin />} />
          <Route
            path="change-password"
            element={
              <PromoProtectedRoute>
                <ChangePassword />
              </PromoProtectedRoute>
            }
          />
          <Route element={<PromoProtectedRoute><PromoLayout /></PromoProtectedRoute>}>
            <Route index element={<Navigate to="/promo/dashboard" replace />} />
            <Route path="dashboard" element={<PromoDashboard />} />
            <Route path="promo-codes" element={<PromoCodes />} />
            <Route path="campaigns" element={<Campaigns />} />
            <Route path="referrals" element={<Referrals />} />
            <Route path="downline" element={<Downline />} />
            <Route path="leaderboard" element={<Leaderboard />} />
            <Route path="contests" element={<Contests />} />
            <Route path="commissions" element={<Commissions />} />
            <Route path="settlements" element={<Settlements />} />
            <Route path="funnel" element={<Funnel />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="forecast" element={<Forecast />} />
            <Route path="payouts" element={<Payouts />} />
            <Route path="tickets" element={<Tickets />} />
            <Route path="security" element={<Security />} />
            <Route path="*" element={<Navigate to="/promo/dashboard" replace />} />
          </Route>
        </Routes>
      </div>
    </PromoAuthProvider>
  );
}
